import type { ViewModeType } from '@atlassian/jira-issue-view-common-types/src/context-type.tsx';
import { VIEW_MODE_STORAGE_KEY, localStorage } from './constants.tsx';

export const getViewModeFromLocalStorage = (): ViewModeType => {
	if (__SERVER__) {
		return 'DEFAULT';
	}
	return localStorage.get(VIEW_MODE_STORAGE_KEY) || 'DEFAULT';
};
